<script lang="ts">
import { getWidgetFieldProps } from '@widgets/shared/compositions/field'
import WidgetFieldTextarea, {
  widgetFieldTextareaProps,
} from '@widgets/shared/components/fields/WidgetFieldTextarea.vue'
import { widgetFormFieldProps } from '@widgets/shared/components/fields/types'
import { mergeProps, defineComponent, h } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    ...widgetFormFieldProps,
    ...widgetFieldTextareaProps,
  },
  setup(props, context) {
    return () => {
      const fieldProps = getWidgetFieldProps(props.name!)
      return h(WidgetFieldTextarea, mergeProps(props, context.attrs, fieldProps))
    }
  },
})
</script>
